import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import RedTemplate from '@/types/table/redTemplate';
import { SealData } from '@/api/generated/sealController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface RedTemplateData extends RedTemplate {
  __cascade_add_temp_id__?: string | number | undefined;
}

export interface RedTemplateWithSeal {
  seal: SealData;
  redTemplate: RedTemplateData;
}

export default class RedTemplateController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<RedTemplateData>>(
      API_CONTEXT + '/upms/redTemplate/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<RedTemplateData>(API_CONTEXT + '/upms/redTemplate/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/redTemplate/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/redTemplate/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/redTemplate/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/redTemplate/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/redTemplate/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/redTemplate/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/redTemplate/deleteBatch', params, httpOptions);
  }
  static queryWithSealByRedTemplateId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<RedTemplateWithSeal>(
      API_CONTEXT + '/upms/redTemplate/queryWithSealByRedTemplateId',
      params,
      httpOptions,
    );
  }
}
